import { render, staticRenderFns } from "./toolsI18nWizardsCatalog.vue?vue&type=template&id=a5fccac0"
import script from "./toolsI18nWizardsCatalog.vue?vue&type=script&lang=js"
export * from "./toolsI18nWizardsCatalog.vue?vue&type=script&lang=js"
import style0 from "./toolsI18nWizardsCatalog.vue?vue&type=style&index=0&id=a5fccac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports